var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6 text-center"},[_vm._v("Finishing Google sign-in…")])
}
var staticRenderFns = []

export { render, staticRenderFns }